import { yupResolver } from '@hookform/resolvers/yup'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import CancelIcon from '@mui/icons-material/Cancel'
import ModeEditIcon from '@mui/icons-material/ModeEdit'
import SaveAsIcon from '@mui/icons-material/SaveAs'
// import DeleteIcon from '@mui/icons-material/Delete'
import { LoadingButton } from '@mui/lab'
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material'
import { useAppSelector } from 'app/hooks'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import axiosClient from 'utils/axiosClient'
import * as yup from 'yup'
import RenderSurvey from './RenderSurvey'
import { useNavigate } from 'react-router-dom'
// import DialogConfirm from 'components/Dialogs/DialogConfirm'

type Props = {
  apiEndpoint?: string
  label: string
  surveyIds: number[]
  eventId: number
}
interface FormInput {
  surveyIds: number[]
}

export default function EditSurvey({
  apiEndpoint,
  surveyIds,
  eventId,
  label,
}: Props) {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const schema = yup.object({
    surveyIds: yup.array().required(),
  })
  const {
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
  } = useForm<FormInput>({
    resolver: yupResolver(schema),
    defaultValues: {
      surveyIds,
    },
  })
  const surveys = useAppSelector((s) => s.UI.surveys)
  const [loading, setLoading] = useState(false)
  const [edit, setEdit] = useState(false)
  // const [deleteConfirm, setDeleteConfirm] = useState(false)
  // const [deleteSurveyId, setDeleteSurveyId] = useState(0)

  const onSubmit: SubmitHandler<FormInput> = async (data) => {
    if (apiEndpoint) {
      console.log(apiEndpoint)
      setLoading(true)
      try {
        await axiosClient.put(apiEndpoint, {
          data: JSON.stringify(data),
        })
        setEdit(false)
        const msg = 'アンケート項目を変更しました。'
        enqueueSnackbar(msg, {
          variant: 'success',
        })
        setLoading(false)
      } catch (_error) {
        const msg = 'エラーが発生しました。'
        enqueueSnackbar(msg, {
          variant: 'error',
        })
      }
    }
  }
  // const deleteSurvey = async () => {
  //   try {
  //     setLoading(true)
  //     // console.log(deleteSurveyId)
  //     // setValue(
  //     //   'surveyIds',
  //     //   getValues('surveyIds').filter(
  //     //     (f) => f !== deleteSurveyId
  //     //   ),
  //     //   {
  //     //     shouldValidate: true,
  //     //   }
  //     // )
  //     console.log(getValues('surveyIds'))
  //     await axiosClient.put('/api/events/' + eventId, {
  //       data: JSON.stringify(getValues('surveyIds')),
  //     })
  //     await axiosClient.put(
  //       '/api/events/' + eventId + '/surveys/' + deleteSurveyId
  //     )
  //     const msg = 'アンケートを削除しました。'
  //     enqueueSnackbar(msg, {
  //       variant: 'success',
  //     })
  //     setEdit(false)
  //     setDeleteConfirm(false)
  //     setTimeout(() => {
  //       navigate('/event/' + eventId)
  //     }, 100)
  //   } catch (error) {
  //     const msg = 'エラーが発生しました。'
  //     enqueueSnackbar(msg, {
  //       variant: 'error',
  //     })
  //   } finally {
  //     setLoading(false)
  //   }
  // }
  return (
    <>
      {/* <DialogConfirm
        open={deleteConfirm}
        maxWidth="xs"
        loading={loading}
        handleSubmit={handleSubmit(deleteSurvey)}
        title="確認"
        primaryButtonText="削除"
        primaryButtonColor="error"
        handleClose={() => setDeleteConfirm(false)}
      >
        <Typography>アンケートを削除しますか？</Typography>
      </DialogConfirm> */}
      <Box
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit(onSubmit)}
        my={2}
      >
        <Stack spacing={2}>
          <Stack direction="row" alignItems="center">
            <Typography fontWeight="bold" variant="body1" flex={'none'}>
              {label}
            </Typography>
            {!edit && (
              <>
                <Button
                  sx={{
                    flex: 'none',
                    mx: 1,
                    p: 0.5,
                    minWidth: 0,
                  }}
                  size="small"
                  variant="contained"
                  color="info"
                  onClick={() => {
                    setEdit(true)
                  }}
                >
                  <ModeEditIcon fontSize="small" />
                </Button>
                <Button
                  variant="outlined"
                  sx={{ my: 1 }}
                  onClick={() => {
                    navigate(`/event/${eventId}/survey`)
                  }}
                >
                  アンケート作成
                </Button>
              </>
            )}
          </Stack>
          <Stack border={edit ? 1 : 0} borderColor="#999">
            {surveys
              .filter((f) => edit || surveyIds.includes(f.id))
              .map((survey) => {
                return (
                  <Stack key={survey.id}>
                    <ListItem>
                      <ListItemIcon sx={{ minWidth: 0 }}>
                        {edit ? (
                          <>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  edge="start"
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{
                                    'aria-labelledby': String(survey.id),
                                  }}
                                  checked={getValues('surveyIds').includes(
                                    survey.id
                                  )}
                                  onChange={(e) => {
                                    const checked = e.target.checked
                                    if (checked) {
                                      if (
                                        !getValues('surveyIds').includes(
                                          survey.id
                                        )
                                      )
                                        setValue(
                                          'surveyIds',
                                          [
                                            ...getValues('surveyIds'),
                                            survey.id,
                                          ],
                                          {
                                            shouldValidate: true,
                                          }
                                        )
                                    } else {
                                      setValue(
                                        'surveyIds',
                                        getValues('surveyIds').filter(
                                          (f) => f !== survey.id
                                        ),
                                        {
                                          shouldValidate: true,
                                        }
                                      )
                                    }
                                  }}
                                />
                              }
                              label={survey.text}
                            />
                            {/* {survey.eventId &&
                              !getValues('surveyIds').includes(survey.id) && (
                                <Button
                                  sx={{
                                    px: 1,
                                    minWidth: 0,
                                  }}
                                  size="small"
                                  color="error"
                                  variant="contained"
                                  onClick={() => {
                                    setDeleteSurveyId(survey.id)
                                    setDeleteConfirm(true)
                                  }}
                                >
                                  <DeleteIcon />
                                </Button>
                              )} */}
                          </>
                        ) : (
                          <ArrowRightIcon fontSize="small" />
                        )}
                      </ListItemIcon>
                      {!edit && (
                        <ListItemText
                          id={String(survey.id)}
                          primary={survey.text}
                        />
                      )}
                    </ListItem>
                    <Box mx={2} p={1} bgcolor="#eee">
                      <Typography>例</Typography>
                      <RenderSurvey survey={survey} />
                    </Box>
                  </Stack>
                )
              })}
            {edit && (
              <Stack spacing={4} direction="row" justifyContent="center" py={2}>
                <Button
                  sx={{
                    px: 1,
                    minWidth: 0,
                  }}
                  size="small"
                  color="error"
                  variant="contained"
                  onClick={() => {
                    setEdit(false)
                    setValue('surveyIds', surveyIds, {
                      shouldValidate: true,
                    })
                  }}
                >
                  <CancelIcon />
                </Button>
                <LoadingButton
                  disabled={Object.keys(errors).length > 0}
                  loading={loading}
                  sx={{
                    px: 1,
                    minWidth: 0,
                  }}
                  size="small"
                  variant="contained"
                  type="submit"
                >
                  <SaveAsIcon />
                </LoadingButton>
              </Stack>
            )}
          </Stack>
        </Stack>
      </Box>
    </>
  )
}
